import { IPublicClientApplication } from "@azure/msal-browser";
import { MsGraphAuthService } from "./MsGraphAuthService";

/**
 * Initialize the MSAL instance
 * This delegates to MsGraphAuthService for centralized management
 */
export const initializeMsalInstance = (
  msal: IPublicClientApplication,
): void => {
  MsGraphAuthService.getInstance().initialize(msal);
};

/**
 * Get the MSAL instance
 * @throws Error if not initialized
 * @deprecated Use MsGraphAuthService.getInstance() directly for new code
 */
export const getMsalInstance = (): IPublicClientApplication => {
  return MsGraphAuthService.getInstance().getMsalInstance();
};

/**
 * Get the centralized auth service instance
 * Preferred method for accessing authentication functionality
 */
export const getAuthService = (): MsGraphAuthService => {
  return MsGraphAuthService.getInstance();
};
